import { hubbleAuthAPI, hubbleAPI } from './url'
import useEnvironment from '~/composable/various/useEnvironment'
const resource = hubbleAuthAPI + 'public/mitid'
const hubbleAPIResource = hubbleAPI + 'public/ct'

export default ($axios) => ({
  fetchToken(code) {
    const { isDevEnv } = useEnvironment();

    let baseUrl = window.location.protocol + '//' + window.location.hostname + '/gw';

    if (isDevEnv()) {
      baseUrl = '/shop';
    }
    const url = `${baseUrl}/HubbleAuthAPI/api/public/mitid/token`;

    const config = { headers: { 'Content-Type': 'text/html' } };
    return $axios.post(url, code, config)
  },
  getUserInfo(mitIdAccessToken) {
    const config = { headers: { 'Content-Type': 'application/json' } }
    return $axios.post(`${resource}/userinfo`, { accessToken: mitIdAccessToken }, config)
  },
  getCprInfoUsingMitIdAccessToken(mitIdAccessToken) {
    const config = { headers: { 'Content-Type': 'application/json' } }
    const url = `${hubbleAPIResource}/get-cpr-data`

    return $axios.post(`${url}`, { accessToken: mitIdAccessToken }, config)
  },
  addAddressInformationToCartByAccessToken(cartID, mitIdAccessToken) {
    const config = { headers: { 'Content-Type': 'application/json' } }
    const url = `${hubbleAPIResource}/lookup-add-address-information/${cartID}`
    return $axios.post(`${url}`, { accessToken: mitIdAccessToken }, config)
  }
})
